"use client";
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import * as React from 'react';
import { Icon } from '../../Icon/Icon.web.js';

var _excluded = ["color", "size"];
var IconSolarPanels = function IconSolarPanels(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === undefined ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    sizeProp = _ref$size === undefined ? '48px' : _ref$size,
    props = _objectWithoutProperties(_ref, _excluded);
  var size = sizeProp;
  return /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement("svg", {
    fill: "none",
    viewBox: "0 0 48 48",
    width: size,
    height: size
  }, /*#__PURE__*/React.createElement("path", {
    fill: color,
    fillRule: "evenodd",
    d: "m35.324 4.417-2-2-.707.707 2 2zm.53.42 1.272 1.545a3 3 0 1 0 3.995 4.47l.137-.142 1.484 1.34a5 5 0 1 1-7.064-7.06zM31 46.964V43h6v-7.414l-1.704-1.704 1.547-1.547 2.756 2.756 3.811-3.81L20.394 8.262l-3.811 3.811 2.753 2.753-1.547 1.547L12 10.586l-6.707 6.707 1.414 1.414L12 13.415l23 23V41h-6v6.478a24 24 0 0 0 2-.515M18.496 17.081l1.547-1.547 16.092 16.093-1.546 1.547zM39 19v-4h-1v4zM33 8v1h-4V8zm2.324 5.124-.707-.708-2 2 .707.708zm8-.708 2 2-.707.708-2-2zM40.58 31.28 20.393 11.092l-.982.982 20.188 20.187zM23 34h-8v12h8zm-2 2v8h-4v-8z",
    clipRule: "evenodd"
  })));
};

export { IconSolarPanels, IconSolarPanels as default };
